import React, {Component} from 'react';
import CountryListPopUp from '../popup/CountryListPopUp';
import {connect} from 'react-redux';
import {withTranslation} from 'react-i18next';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {getAppFromSessionData, updateDefaultCountry} from '../../ducks/sessionData';
import axios from 'axios';
import {AXIOS_CLIENT_TIMEOUT} from '../../utils/globalConstants';
import {URL_GET_APP_DETAIL_API, URL_GET_COUNTRY_DATA_API, URL_GET_COUNTRY_INFORMATION_API, URL_GET_SETTINGS_INSTANT_TERMINATION, URL_GET_SETTINGS_PAYMENT_CONSENT, URL_SET_DEFAULT_COUNTRY_API, URL_UPDATE_CP_APP, URL_UPDATE_SETTINGS_INSTANT_TERMINATION, URL_UPDATE_SETTINGS_PAYMENT_CONSENT} from '../../utils/urlConstants';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {handleHttpError} from '../../utils/ErrorUtils';
import {startLoading, stopLoading} from '../../ducks/loading';
import {triggerGetSessionData} from "../App";
import {fetchCountries} from '../../utils/CountryListUtils';
import {loadCountriesInformation} from '../../ducks/countriesInformation';
import ReminderURLComponent from "./ReminderURLComponent";
import BasePopup from '../popup/BasePopup';
import DataTableWrapperForSettingSubscriptionTermination from '../datable/DataTableWrapperForSettingSubscriptionTermination';
import DataTableWrapperForSettingPaymentConsent from '../datable/DataTableWrapperForSettingPaymentConsent';

const DEFAULT_GRACE_PERIOD_IN_DAYS = 3;

function ButtonWrapper(props) {
  return (
      <div className="input-group-append">
        <button className={props.className} type="button" onClick={props.onClick} style={props.style} disabled={props.disabled}>{props.label}</button>
      </div>
  )
}

class AppDetailsSettingPanel extends Component {

  constructor(props) {
    super(props);
    this.httpClient = axios.create({timeout: AXIOS_CLIENT_TIMEOUT});
    this.state = {
      open: false,
      readOnly: false,
      selectedCountries: [],
      countryDataLoaded: false,
      countryData: [],
      appSecKey: "",
      appGracePeriod: 0,
      appGracePeriodModal: false,

      openModalTermination: false,
      openModalPaymentConsent: false,
      // for data table
      subscriptionTerminationByCountryData: [],
      selectedCountriesForTermination: [],
      selectedCountriesForPaymentConsent: [],
      savePopUpTermination: false,
      savePopUpPaymentConsent: false,

      paymentConsentByCountryData: [],
      countryTerminationList: [],

      isDataPaymentConsentChanged: false,
      isDataSubscriptionTerminationChanged: false,
    }
  }

  initData = () => {
    if (!this.props.sessionData.apps) {
      return;
    }
    if (this.props.sessionData.apps.length && this.state.countryData.length) {
      const app = getAppFromSessionData(this.props.sessionData, this.props.carousel.selectedAppId);

      this.setState({
        selectedCountries: app.defaultCountry ? [app.defaultCountry] : [],
        countryDataLoaded: true
      });
      this.getAppDetail(this.props.carousel.selectedAppId);
      this.getSubscriptionTerminationInfo(this.props.carousel.selectedAppId)
      this.getPaymentConsentInfo(this.props.carousel.selectedAppId)
    }
  };

  getAppDetail = (selectedAppId) => {
    this.httpClient
        .get(URL_GET_APP_DETAIL_API, {params: {cpAppId: selectedAppId}})
        .then((response) => {
          this.setState({appSecKey: response.data.secKey})
          this.setState({appGracePeriod: response.data.appGracePeriod ? (response.data.appGracePeriod / 24) : DEFAULT_GRACE_PERIOD_IN_DAYS}) //Convert to Days
        })
  }

  getSubscriptionTerminationInfo = (selectedAppId) => {
    this.httpClient
        .get(URL_GET_SETTINGS_INSTANT_TERMINATION, {params: {cpAppId: selectedAppId}})
        .then((response) => {
          const responseList = response.data.map(item => ({
            ...item,
            withdrawalPeriod: item.withdrawalPeriod / 24, // Convert to days
            isSelected: false
          }));

          // Extract countryCode to a list
          const countryCodeList = responseList.map(item => item.countryCode);
          this.setState({subscriptionTerminationByCountryData: responseList, selectedCountriesForTermination: countryCodeList})
        })
  }

  getPaymentConsentInfo = (selectedAppId) => {
    this.httpClient
        .get(URL_GET_SETTINGS_PAYMENT_CONSENT, {params: {cpAppId: selectedAppId}})
        .then((response) => {
          const responseList = response.data.map(item => ({
            ...item,
            consentCollectionPeriod: item.consentCollectionPeriod / 24,// Convert to days
            notificationCycle: item.notificationCycle / 24, // Convert to days
            isSelected: false
          }));

          // Extract countryCode to a list
          const countryCodeList = responseList.map(item => item.countryCode);
          this.setState({paymentConsentByCountryData: responseList, selectedCountriesForPaymentConsent: countryCodeList})
        })
  }

  handleSaveSubscriptionTermination = () => {
    this.setState({savePopUpTermination: false})
    let validPeriodFlag = false;
    this.state.subscriptionTerminationByCountryData.forEach((e) => {
      if (!e.withdrawalPeriod || e.withdrawalPeriod < 1 || e.withdrawalPeriod > 31) {
        validPeriodFlag = true;
      }
    });
    if (validPeriodFlag) {
      toast(this.props.t("SUBSCRIPTION_TERMINATION_ALERT_ERROR_PERIOD"));
      return Promise.resolve(null);
    }

    let params = {
      cpAppId: this.props.carousel.selectedAppId,
      instantTerminationList: this.state.subscriptionTerminationByCountryData.map((e) => {
        return {
          countryCode: e.countryCode,
          withdrawalPeriod: e.withdrawalPeriod * 24
        }
      }),
    };

    return new Promise((resolve, reject) => {
      this.props.startLoading();
      this.httpClient
          .post(URL_UPDATE_SETTINGS_INSTANT_TERMINATION, params)
          .then(() => {
            this.props.stopLoading();
            triggerGetSessionData();

            toast(this.props.t("SUBSCRIPTION_TERMINATION_UPDATE_SUCCESS"))
            resolve();
            this.setState({isDataSubscriptionTerminationChanged: false});
          })
          .catch(error => {
            handleHttpError(this.props.t, this.props.history, error);
            reject();
            this.props.stopLoading();
          });
    });

  };
  handleSavePaymentConsent = () => {
    this.setState({savePopUpPaymentConsent: false})
    let validConsentPeriodFlag = false;
    let validNotifPeriod = false;
    this.state.paymentConsentByCountryData.forEach((e) => {
      if (!e.consentCollectionPeriod || e.consentCollectionPeriod < 1 || e.consentCollectionPeriod > 31) {
        validConsentPeriodFlag = true;
      }

      if (!e.notificationCycle || e.notificationCycle < 2 || e.notificationCycle > 7) {
        validNotifPeriod = true;
      }
    });

    if (validConsentPeriodFlag) {
      toast(this.props.t("PAYMENT_CONSENT_ALERT_CONSENT_PERIOD"));
      return Promise.resolve(null);
    }

    if (validNotifPeriod) {
      toast(this.props.t("PAYMENT_CONSENT_ALERT_NOTIF_PERIOD"));
      return Promise.resolve(null);
    }

    let params = {
      cpAppId: this.props.carousel.selectedAppId,
      paymentConsentList: this.state.paymentConsentByCountryData.map((e) => {
        return {
          countryCode: e.countryCode,
          consentCollectionPeriod: e.consentCollectionPeriod * 24,
          notificationCycle: e.notificationCycle * 24
        }
      }),
    };

    return new Promise((resolve, reject) => {
      this.props.startLoading();
      this.httpClient
          .post(URL_UPDATE_SETTINGS_PAYMENT_CONSENT, params)
          .then(() => {
            this.props.stopLoading();
            triggerGetSessionData();
            toast(this.props.t("PAYMENT_CONSENT_UPDATE_SUCCESS"))
            resolve();
            this.setState({isDataPaymentConsentChanged: false});
          })
          .catch(error => {
            handleHttpError(this.props.t, this.props.history, error);
            reject();
            this.props.stopLoading();
          });
    });

  };

  convertToTerminationInformationByCountries = (selectedCountries) => {
    return selectedCountries.map(country => {
      const isAlreadyAdded = this.checkNewCountryAdded(country, this.state.subscriptionTerminationByCountryData);
      if (isAlreadyAdded) {
        return isAlreadyAdded;
      } else {
        return {
          countryCode: country,
          cpAppId: this.props.carousel.selectedAppId,
          withDrawalPeriod: 0,
          isSelected: false
        }
      }
    });
  };

  convertToPaymentConsentInformationByCountries = (selectedCountries) => {
    return selectedCountries.map(country => {
      const isAlreadyAdded = this.checkNewCountryAddedForPaymentConsent(country, this.state.paymentConsentByCountryData);
      if (isAlreadyAdded) {
        return isAlreadyAdded;
      } else {
        return {
          countryCode: country,
          cpAppId: this.props.carousel.selectedAppId,
          withDrawalPeriod: 0,
          isSelected: false
        }
      }
    });
  };

  handleCheckCountryTermination = (country, isDisabled) => {
    if (!isDisabled) {
      this.setState(prevState => {
        return {
          subscriptionTerminationByCountryData: prevState.subscriptionTerminationByCountryData.map((item) => {
            if (item.countryCode === country) {
              item.isSelected = !item.isSelected;
            }
            return item;
          })
        }
      });
    }
  };

  handleCheckPaymentConsent = (country, isDisabled) => {
    if (!isDisabled) {
      this.setState(prevState => {
        return {
          paymentConsentByCountryData: prevState.paymentConsentByCountryData.map((item) => {
            if (item.countryCode === country) {
              item.isSelected = !item.isSelected;
            }
            return item;
          })
        }
      });
    }
  };

  handleCheckAllCountryTermination = () => {
    const allChecked = this.state.subscriptionTerminationByCountryData.map(item => item.isSelected).every(item => item);
    this.setState(prevState => {
      return {
        subscriptionTerminationByCountryData: prevState.subscriptionTerminationByCountryData.map((item) => {
          item.isSelected = !allChecked;
          return item;
        })
      }
    });
  };

  handleCheckAllCountryPaymentConsent = () => {
    const allChecked = this.state.paymentConsentByCountryData.map(item => item.isSelected).every(item => item);
    this.setState(prevState => {
      return {
        paymentConsentByCountryData: prevState.paymentConsentByCountryData.map((item) => {
          item.isSelected = !allChecked;
          return item;
        })
      }
    });
  };

  checkNewCountryAdded = (country, terminationInformationByCountries) => {
    let oldInfo = null;
    terminationInformationByCountries.forEach(item => {
      if (item.countryCode === country) {
        oldInfo = item;
      }
    });
    return oldInfo;
  };

  checkNewCountryAddedForPaymentConsent = (country, paymentConsentByCountryData) => {
    let oldInfo = null;
    paymentConsentByCountryData.forEach(item => {
      if (item.countryCode === country) {
        oldInfo = item;
      }
    });
    return oldInfo;
  };

  handleModalOpenTermination = () => {
    this.setState({
      readOnly: false,
      openModalTermination: true,
    });
  };

  handleModalOpenPaymentConsent = () => {
    this.setState({
      readOnly: false,
      openModalPaymentConsent: true,
    });
  };

  handleModalOpen = () => {
    this.setState({
      open: true,
      readOnly: false,
    });
  };

  handleListOpen = () => {
    this.setState({
      open: true,
      readOnly: true,
    });
  };

  handleModalCloseTermination = (isSave, selectedCountries) => {
    this.setState({openModalTermination: false});

    if (!isSave) {
      return Promise.resolve(this.props.t("CONDITION_NOT_MET"));
    }

    this.setState({
      isDataSubscriptionTerminationChanged : true,
      selectedCountriesForTermination: selectedCountries,
      subscriptionTerminationByCountryData: this.convertToTerminationInformationByCountries(selectedCountries)
    });
    this.setState({subscriptionTerminationByCountryData: this.convertToTerminationInformationByCountries(selectedCountries)});
    return Promise.resolve("");

  }

  handleModalPaymentConsent = (isSave, selectedCountries) => {
    this.setState({openModalPaymentConsent: false});

    if (!isSave) {
      return Promise.resolve(this.props.t("CONDITION_NOT_MET"));
    }

    this.setState({
      selectedCountriesForPaymentConsent: selectedCountries,
      paymentConsentByCountryData: this.convertToPaymentConsentInformationByCountries(selectedCountries),
      isDataPaymentConsentChanged: true
    });
    return Promise.resolve("");
  }

  handleModalClose = (isSave, selectedCountries) => {
    this.setState({open: false});

    if (!isSave) {
      return Promise.resolve(this.props.t("CONDITION_NOT_MET"));
    }

    this.setState({selectedCountries: selectedCountries});

    return new Promise((resolve, reject) => {
      this.props.startLoading();
      this.httpClient
          .post(URL_SET_DEFAULT_COUNTRY_API, {cpAppId: this.props.carousel.selectedAppId, countryCode: selectedCountries[0]})
          .then(() => {
            this.props.updateDefaultCountry(selectedCountries[0], this.props.carousel.selectedAppId);
            this.props.stopLoading();
            triggerGetSessionData();
            resolve();
          })
          .catch(error => {
            handleHttpError(this.props.t, this.props.history, error);
            reject();
            this.props.stopLoading();
          });
    });
  };

  handleDeleteCountryTermination = () => {
    this.setState(prevState => {
      let newListCountries = prevState.subscriptionTerminationByCountryData.filter(function (item) {
        return !item.isSelected;
      });
      return {
        isDataSubscriptionTerminationChanged: true,
        subscriptionTerminationByCountryData: newListCountries,
        selectedCountriesForTermination: newListCountries.map(item => item.countryCode)
      }
    });
  };

  handleDeletePaymentConsent = () => {
    this.setState(prevState => {
      let newListCountries = prevState.paymentConsentByCountryData.filter(function (item) {
        return !item.isSelected;
      });
      return {
        isDataPaymentConsentChanged: true,
        paymentConsentByCountryData: newListCountries,
        selectedCountriesForPaymentConsent: newListCountries.map(item => item.countryCode)
      }
    });
  };

  handleGracePeriodUpdate = () => {

    if (this.state.appGracePeriod < 1 || this.state.appGracePeriod > 16) {
      toast(this.props.t("GRACE_PERIOD_INVALID"));
      this.toggleGracePeriodModal();
      return Promise.resolve(this.props.t("CONDITION_NOT_MET"));
    }

    return new Promise((resolve, reject) => {
      this.props.startLoading();
      this.httpClient
          .post(URL_UPDATE_CP_APP, {cpAppId: this.props.carousel.selectedAppId, appGracePeriod: this.state.appGracePeriod * 24}) //Submit grace period in hours
          .then(() => {
            this.props.stopLoading();
            triggerGetSessionData();
            this.toggleGracePeriodModal();
            toast(this.props.t("GRACE_PERIOD_UPDATE_SUCCESS"))
            resolve();
          })
          .catch(error => {
            handleHttpError(this.props.t, this.props.history, error);
            reject();
            this.props.stopLoading();
            this.toggleGracePeriodModal();
          });
    });
  };

  handlePeriodTerminationChange = (country, event) => {
    let input = event.target.value;

    this.setState(prevState => {
      return {
        isDataSubscriptionTerminationChanged: true,
        subscriptionTerminationByCountryData: prevState.subscriptionTerminationByCountryData.map((item) => {
          if (item.countryCode === country) {
            item.withdrawalPeriod = input;
          }
          return item;
        })
      }
    });
  };

  handleConsentCollectionPeriodChange = (country, event) => {
    let input = event.target.value;

    this.setState(prevState => {
      return {
        isDataPaymentConsentChanged: true,
        paymentConsentByCountryData: prevState.paymentConsentByCountryData.map((item) => {
          if (item.countryCode === country) {
            item.consentCollectionPeriod = input;
          }
          return item;
        })
      }
    });
  };

  handleNotifPeriodChange = (country, event) => {
    let input = event.target.value;

    this.setState(prevState => {
      return {
        isDataPaymentConsentChanged: true,
        paymentConsentByCountryData: prevState.paymentConsentByCountryData.map((item) => {
          if (item.countryCode === country) {
            item.notificationCycle = input;
          }
          return item;
        })
      }
    });
  };

  handleOnChangeGracePeriod = (e) => {
    this.setState({
      appGracePeriod: e.target.value
    })
  }
  toggleGracePeriodModal = () => {
    this.setState((prevState) => ({
      appGracePeriodModal: !prevState.appGracePeriodModal
    }))
  }

  initCountryData = () => {
    this.props.startLoading();
    fetchCountries(URL_GET_COUNTRY_DATA_API, this.props.t, this.props.history)
        .then(countryData => {
          this.setState({countryData: countryData});
          fetchCountries(URL_GET_COUNTRY_INFORMATION_API, this.props.t, this.props.history)
              .then((countryInformation => {
                this.props.loadCountriesInformation(countryInformation);
                this.initData();
                this.props.stopLoading();
              }));
        });
  };

  render() {
    if (!this.state.countryDataLoaded) {
      return <div/>;
    }

    const {open, selectedCountries, selectedCountriesForTermination, selectedCountriesForPaymentConsent, readOnly, openModalTermination, openModalPaymentConsent,} = this.state;

    const app = this.props.sessionData.apps.find((appItem) => appItem.appId === this.props.carousel.selectedAppId);
    return (
        <div className="tab-pane active" role="tabpanel">
          <div className="clearfix mb-20">
            <h2 className="float-left mb-0"><strong>{this.props.t('APP_INFORMATION')}</strong></h2>
          </div>
          <div className="form-group-wrap">
            <div className="form-group row">
              <label className="col col-form-label">{this.props.t('APP_ID')}</label>
              <div className="col">
                <input type="text" className="form-control" value={app.appId} readOnly="readonly"/>
              </div>
            </div>
            <div className="form-group row">
              <label className="col col-form-label">{this.props.t('APP_NAME')}</label>
              <div className="col">
                <input type="text" className="form-control" value={app.name ? app.name : ""} readOnly="readonly"/>
              </div>
            </div>
          </div>
          <div className="clearfix mb-20 mt-60">
            <h2 className="float-left mb-0"><strong>{this.props.t('APP_SECURITY_KEY')}</strong></h2>
          </div>
          <div className="form-group-wrap">
            <div className="form-group row">
              <label className="col col-form-label">{this.props.t('SECURITY_KEY')}</label>
              <div className="col">
                <div className="input-group">
                  <input type="text" value={this.state.appSecKey} className="form-control" readOnly={true}/>
                  <CopyToClipboard text={this.state.appSecKey} onCopy={() => {
                    toast(this.state.appSecKey !== null ? this.props.t("COPIED_URL") : this.props.t("COPIED_URL_EMPTY"));
                  }}>
                    <div className="input-group-append">
                      <button className="btn btn-primary" type="button">{this.props.t('COPY')}</button>
                    </div>
                  </CopyToClipboard>
                </div>
              </div>
            </div>
          </div>
          <div className="clearfix mb-20 mt-60">
            <h2 className="float-left mb-0"><strong>{this.props.t('DEFAULT_COUNTRY_SETTING')}</strong></h2>
          </div>
          <div className="form-group-wrap" id="app-details-setting-default-country-location-setting">
            <div className="form-group row">
              <label className="col col-form-label">{this.props.t('DEFAULT_COUNTRY')}</label>
              <div className="col">
                <div className="row">
                  <div className="col-3">
                    <div className="input-group">
                      {!selectedCountries.length ? (
                          <div className="input-group-append flex-100">
                            <span className="input-group-text w-100 border-0 bg-white pl-0 text-muted">{this.props.t('PLEASE_SET_DEFAULT_COUNTRY')}</span>
                          </div>
                      ) : (
                          <div className="flex-100 align-items-center">
                            <ul className="list-inline mb-0 mt-2">
                              <li className="list-inline-item">
                                <div className="btn-group-toggle btn-group-checkbox">
                                  <label className="btn-checkbox checked disabled"><input type="checkbox" checked={true} readOnly={true}/></label>
                                </div>
                                <span className="ml-6 mr-10">{this.props.t(selectedCountries[0])} ({this.props.t('DEFAULT')})</span>
                              </li>
                            </ul>
                          </div>
                      )}
                    </div>
                  </div>
                  <ButtonWrapper
                      className="btn btn-auto btn-primary rounded"
                      onClick={this.handleModalOpen}
                      label={selectedCountries.length ? this.props.t('CHANGE') : this.props.t('SETTING')}
                      style={{minWidth: "6rem"}}
                  />
                </div>
              </div>
            </div>
            <div className="form-group row">
              <label className="col col-form-label">{this.props.t('CHECKOUT_SUPPORTED')}<br/>{this.props.t('COUNTRIES')}</label>
              <div className="col">
                <div className="row">
                  <div className="col-3">
                    <div className="input-group">
                      <div className="flex-100 align-items-center">
                        <ul className="list-inline mb-0 mt-2">
                          <li className="list-inline-item">
                            <div className="btn-group-toggle btn-group-checkbox">
                              <label className="btn-checkbox active disabled"><input type="checkbox" checked={true} readOnly={true}/></label>
                            </div>
                            <span className="ml-6 mr-10">{this.props.countriesInformation.length} {this.props.t('COUNTRIES')}</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <ButtonWrapper
                      className="btn btn-auto btn-outline-primary rounded"
                      onClick={this.handleListOpen}
                      label={this.props.t('VIEW')}
                      style={{minWidth: "6rem"}}
                  />
                </div>
              </div>
            </div>
          </div>


          {/*Grace Period Settings*/}
          <div className="clearfix mt-60">
            <h2 className="float-left mb-0"><strong>{this.props.t('GRACE_PERIOD')}</strong></h2>
            <h2 type="text" data-toggle="tooltip" data-placement="top" title={this.props.t("GRACE_PERIOD_TOOLTIP_MSG")}>&nbsp; ⓘ</h2>

          </div>

          <div className="clearfix mb-20">
            <strong>
              <h4 className="float-left mb-0">{this.props.t('GRACE_PERIOD_SETTING_DETAIL')}</h4>
              <br/>
              <h4 className="float-left mb-0">{this.props.t('GRACE_PERIOD_SETTING_DETAIL_2')}</h4>
            </strong>
          </div>
          <div className="form-group-wrap">
            <div className="row">
              <div className="form-group row">
                <label className="col col-form-label">{this.props.t('GRACE_PERIOD')}</label>
                <div className="col ml-0">
                  <div className="col-6 input-group form-inline ml-0">
                    <input className="form-control ml-0" type="number" value={this.state.appGracePeriod} onChange={(e) => {
                      this.handleOnChangeGracePeriod(e)
                    }}/>
                    <h4 className="ml-2 my-auto">Day(s)</h4>
                  </div>
                  <div className="col">
                    <div className="float-left mb-0 mt-1">{this.props.t('GRACE_PERIOD_LIMIT_MSG')}</div>
                  </div>
                </div>
              </div>

              <div className="input-group-append mb-auto ml-2">
                <button className="btn btn-primary" type="button" onClick={this.toggleGracePeriodModal}>{this.props.t('UPDATE')}</button>
              </div>
            </div>


          </div>

          {/*Consent for Payment*/}
          <div className="clearfix mt-60">
            <h2 className="float-left mb-0"><strong>{this.props.t('PAYMENT_CONSENT')}</strong></h2>
            <h2 type="text" data-toggle="tooltip" data-placement="top" title={this.props.t("PAYMENT_CONSENT_TOOLTIP_MSG")}>ⓘ</h2>

          </div>

          <div className="clearfix mb-20">
            <strong>
              <h4 className="float-left mb-0">{this.props.t('PAYMENT_CONSENT_SETTING_DETAIL')}</h4>
            </strong>
          </div>
          <div className="form-group-wrap">
            <div className="form-group row">
              <label className="col col-form-label">{this.props.t('COUNTRIES')}</label>
              <div className="col mb-10">

                <div className="btn-group">
                  <ButtonWrapper
                      className="btn mr-2 btn-auto btn-primary rounded"
                      onClick={this.handleModalOpenPaymentConsent}
                      label={this.props.t('ADD')}
                      style={{minWidth: "6rem"}}
                  />

                  {this.state.isDataPaymentConsentChanged || (this.state.paymentConsentByCountryData && this.state.paymentConsentByCountryData.length > 0) ? (
                      <>
                        <ButtonWrapper
                            className="btn mr-2 btn-auto btn-outline-primary rounded"
                            onClick={() => this.setState({savePopUpPaymentConsent: true})}
                            label={this.props.t('Update')}
                            disabled={!(this.state.isDataPaymentConsentChanged)}
                            style={{minWidth: "6rem"}}
                        />
                        <ButtonWrapper
                            className="btn mr-2 btn-auto btn-outline-primary rounded"
                            label={this.props.t('DELETE')}
                            onClick={this.handleDeletePaymentConsent}
                            disabled={!(this.state.paymentConsentByCountryData.map(item => item.isSelected).some(item => item))}
                            style={{minWidth: "6rem"}}
                        />
                      </>
                  ) : null}
                </div>
              </div>
              {this.state.paymentConsentByCountryData && this.state.paymentConsentByCountryData.length > 0 ? (
                  <div className="col-8">
                    <DataTableWrapperForSettingPaymentConsent
                        paymentConsentByCountryData={this.state.paymentConsentByCountryData}
                        handleCheck={this.handleCheckPaymentConsent}
                        handleCheckAll={this.handleCheckAllCountryPaymentConsent}
                        handleConsentCollectionPeriodChange={this.handleConsentCollectionPeriodChange}
                        handleNotifPeriodChange={this.handleNotifPeriodChange}
                    />
                  </div>
              ) : null}
            </div>


          </div>

          {/*Instant Subscription Termination & refund Setting*/}
          <div className="clearfix mt-60">
            <h2 className="float-left mb-0"><strong>{this.props.t("INSTANT_SUBSCRIPTION_TERMINATION")}</strong></h2>
            <h2 type="text" data-toggle="tooltip" data-placement="top" title={this.props.t("SUBSCRIPTION_TERMINATION_TOOLTIP_MSG")}>ⓘ</h2>

          </div>

          <div className="clearfix mb-20">
            <strong>
              <h4 className="float-left mb-0">{this.props.t('INSTANT_SUBSCRIPTION_TERMINATION_SETTING_DETAIL')}</h4>
            </strong>
          </div>
          <div className="form-group-wrap">
            <div className="form-group row">
              <label className="col col-form-label">{this.props.t('COUNTRIES')}</label>
              <div className="col mb-10">

                <div className="btn-group">
                  <ButtonWrapper
                      className="btn mr-2 btn-auto btn-primary rounded"
                      onClick={this.handleModalOpenTermination}
                      label={this.props.t('ADD')}
                      style={{minWidth: "6rem"}}
                  />

                  {this.state.isDataSubscriptionTerminationChanged || (this.state.subscriptionTerminationByCountryData && this.state.subscriptionTerminationByCountryData.length > 0) ? (
                      <>
                        <ButtonWrapper
                            className="btn mr-2 btn-auto btn-outline-primary rounded"
                            onClick={() => this.setState({savePopUpTermination: true})}
                            label={this.props.t('Update')}
                            disabled={!(this.state.isDataSubscriptionTerminationChanged)}
                            style={{minWidth: "6rem"}}
                        />
                        <ButtonWrapper
                            className="btn mr-2 btn-auto btn-outline-primary rounded"
                            onClick={this.handleDeleteCountryTermination}
                            disabled={!(this.state.subscriptionTerminationByCountryData.map(item => item.isSelected).some(item => item))}
                            label={this.props.t('DELETE')}
                            style={{minWidth: "6rem"}}
                        />
                      </>
                  ) : null}
                </div>
              </div>
              {this.state.subscriptionTerminationByCountryData && this.state.subscriptionTerminationByCountryData.length > 0 ? (
                  <div className="col-6">
                    <DataTableWrapperForSettingSubscriptionTermination
                        subscriptionTerminationCountryData={this.state.subscriptionTerminationByCountryData}
                        handleCheck={this.handleCheckCountryTermination}
                        handlePeriodTerminationChange={this.handlePeriodTerminationChange}
                        handleCheckAll={this.handleCheckAllCountryTermination}/>
                  </div>
              ) : null}
            </div>


          </div>


          <BasePopup
              open={this.state.appGracePeriodModal}
              className="modal-sm"
              title={this.props.t('CONFIRMATION')}
              onClose={this.toggleGracePeriodModal}
              body={
                <>
                  <p>{this.props.t('GRACE_PERIOD_MODAL_MSG')}</p>
                </>
              }
              footer={
                <>
                  <button type="button" className="btn btn-secondary" onClick={this.handleGracePeriodUpdate}>
                    {("Yes, Update")}
                  </button>
                  <button type="button" className="btn btn-outline-secondary" onClick={this.toggleGracePeriodModal}>
                    {("CANCEL")}
                  </button>
                </>
              }/>

          <BasePopup
              open={this.state.savePopUpTermination}
              className="modal-sm"
              title={this.props.t('CONFIRMATION')}
              onClose={() => this.setState({savePopUpTermination: false})}
              body={
                <>
                  <p>{this.props.t('SUBSCRIPTION_TERMINATION_MODAL_MSG')}</p>
                </>
              }
              footer={
                <>
                  <button type="button" className="btn btn-secondary" onClick={() => this.handleSaveSubscriptionTermination(false)}>
                    {("Yes, Update")}
                  </button>
                  <button type="button" className="btn btn-outline-secondary" onClick={() => this.setState({savePopUpTermination: false})}>
                    {("CANCEL")}
                  </button>
                </>
              }/>

          <BasePopup
              open={this.state.savePopUpPaymentConsent}
              className="modal-sm"
              title={this.props.t('CONFIRMATION')}
              onClose={() => this.setState({savePopUpPaymentConsent: false})}
              body={
                <>
                  <p>{this.props.t('PAYMENT_CONSENT_MODAL_MSG')}</p>
                </>
              }
              footer={
                <>
                  <button type="button" className="btn btn-secondary" onClick={() => this.handleSavePaymentConsent(false)}>
                    {("Yes, Update")}
                  </button>
                  <button type="button" className="btn btn-outline-secondary" onClick={() => this.setState({savePopUpPaymentConsent: false})}>
                    {("CANCEL")}
                  </button>
                </>
              }/>

          {/*Webhook Related UI Here*/}
          <ReminderURLComponent selectedAppId={this.props.carousel.selectedAppId}/>

          <CountryListPopUp
              countryData={this.state.countryData}
              open={open}
              title={this.props.t("CHECKOUT_SUPPORTED_COUNTRIES")}
              readOnly={readOnly}
              initCountries={selectedCountries}
              disabledCountry={[]}
              handleModalClose={this.handleModalClose}
              isMultipleSelect={false}
              isContinentSelect={false}
          />

          <CountryListPopUp
              countryData={this.state.countryData}
              open={openModalTermination}
              title={this.props.t("CHECKOUT_SUPPORTED_COUNTRIES")}
              readOnly={readOnly}
              initCountries={selectedCountriesForTermination}
              disabledCountry={[]}
              handleModalClose={this.handleModalCloseTermination}
              isMultipleSelect={true}
              isContinentSelect={false}
          />

          <CountryListPopUp
              countryData={this.state.countryData}
              open={openModalPaymentConsent}
              title={this.props.t("CHECKOUT_SUPPORTED_COUNTRIES")}
              readOnly={readOnly}
              initCountries={selectedCountriesForPaymentConsent}
              disabledCountry={[]}
              handleModalClose={this.handleModalPaymentConsent}
              isMultipleSelect={true}
              isContinentSelect={false}
          />
        </div>
    );
  }

  componentDidMount() {
    this.initCountryData();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.carousel.selectedAppId !== prevProps.carousel.selectedAppId) {
      this.initCountryData();
    }
  }
}

const mapStateToProps = (state) => {
  return {
    carousel: state.carousel,
    sessionData: state.sessionData,
    countriesInformation: state.countriesInformation,
  };
};

const mapDispatchToProps = {
  loadCountriesInformation: loadCountriesInformation,
  updateDefaultCountry: updateDefaultCountry,
  startLoading: startLoading,
  stopLoading: stopLoading
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(AppDetailsSettingPanel));
